export const appsettings = {
    host : process.env.VUE_APP_HOST,
    reCaptchaKey : process.env.VUE_APP_RECAPTCHAKEY
}